/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClassListResponse
 */
export interface ClassListResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof ClassListResponse
     */
    classIds: Array<string>;
}

/**
 * Check if a given object implements the ClassListResponse interface.
 */
export function instanceOfClassListResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "classIds" in value;

    return isInstance;
}

export function ClassListResponseFromJSON(json: any): ClassListResponse {
    return ClassListResponseFromJSONTyped(json, false);
}

export function ClassListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClassListResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'classIds': json['classIds'],
    };
}

export function ClassListResponseToJSON(value?: ClassListResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'classIds': value.classIds,
    };
}

